import type { ProjectFilters } from './project/types'
import { createFilterStore } from './factories'

const normalizeStringArrayFilter = (value: unknown): string[] => {
  const values = Array.isArray(value)
    ? value
    : typeof value === 'string'
      ? [value]
      : []

  return Array.from(
    new Set(
      values
        .filter((item): item is string => typeof item === 'string')
        .map(item => item.trim())
        .filter(Boolean),
    ),
  )
}

// Default filters
const DEFAULT_FILTERS: ProjectFilters = {
  name: '',
  sortBy: 'createdAt',
  sortOrder: 'desc',
  page: 1,
  limit: 50,
  includeCustomFields: true,
}

export const useProjectFiltersStore = createFilterStore<ProjectFilters>({
  storageKey: 'project-filters-storage',
  defaultFilters: DEFAULT_FILTERS,
  autoResetPage: true,
  resetPageFields: ['name', 'columnFilters', 'status', 'memberIds', 'endDateFrom', 'endDateTo', 'sortBy', 'sortOrder'],
  sanitizePersistedFilters: persisted => {
    const next = { ...persisted }
    const columnFilters =
      next.columnFilters &&
      typeof next.columnFilters === 'object' &&
      !Array.isArray(next.columnFilters)
        ? { ...(next.columnFilters as Record<string, unknown>) }
        : {}

    const legacyStatus = normalizeStringArrayFilter(next.status)
    if (legacyStatus.length > 0 && !columnFilters.status) {
      columnFilters.status = legacyStatus
    }
    delete next.status

    const entityIds = normalizeStringArrayFilter(columnFilters.entityId)
    if (entityIds.length > 0) {
      columnFilters.entityId = entityIds
      delete next.entityId
      if (next.moduleType === 'ENTITY') {
        delete next.moduleType
        delete next.moduleId
      }
    } else {
      delete columnFilters.entityId
    }

    const statusIds = normalizeStringArrayFilter(columnFilters.status)
    if (statusIds.length > 0) {
      columnFilters.status = statusIds
    } else {
      delete columnFilters.status
    }

    next.columnFilters =
      Object.keys(columnFilters).length > 0 ? columnFilters : undefined

    return next
  },
})
